// Display helpers in shop time (Asia/Bangkok, fixed +7).
import { addDays, fmtHHMM, fmtThaiDate, instantAt, localDate, localMinutes, parseHHMM, weekday } from '@core/time.ts';

export const SHOP_OFF = 420;
const DOW = ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'];

export const timeOf = (iso: string) => fmtHHMM(localMinutes(new Date(iso), SHOP_OFF));
export const dateOf = (iso: string) => localDate(new Date(iso), SHOP_OFF);
export const thaiDate = (date: string) => fmtThaiDate(date);
export const thaiDateTime = (iso: string) => `${fmtThaiDate(dateOf(iso))} ${timeOf(iso)} น.`;
export const todayLocal = () => localDate(new Date(), SHOP_OFF);
export const dayParts = (date: string) => ({ dow: DOW[weekday(date)], day: Number(date.slice(8, 10)) });
export const shiftDate = (date: string, n: number) => addDays(date, n);
/** ISO instant for a local date + "HH:MM". */
export const isoAt = (date: string, hhmm: string) => instantAt(date, parseHHMM(hhmm), SHOP_OFF).toISOString();
export const minutesUntil = (iso: string) => (new Date(iso).getTime() - Date.now()) / 60_000;
export const fmtMinutes = (m: number) => fmtHHMM(m);
